import React, { useState } from 'react';
import {
  Button, Input, Space, notification,
} from 'antd';
import zoneStore, { updateZoneStore } from '../../Store';
import api from '../../../utils/api';
import FieldLabel, { PanelTitle } from './FieldLabel';

function ZonePanel() {
  const zone = zoneStore.useState((s) => s);
  const [formData, setFormData] = useState({
    name: zone.name || '',
    longname: zone.longname || '',
    description: zone.description || '',
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const apply = async () => {
    const prevState = zoneStore.getRawState();
    const nextState = { ...prevState, ...formData };

    updateZoneStore(nextState);

    const res = await api.updateZone({ ...nextState });

    if (res.status) {
      notification.success({ message: 'Зона обновлена' });
      return;
    }

    updateZoneStore(prevState);
    notification.error({ message: res.errMessage });
  };

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <PanelTitle>Параметры зоны</PanelTitle>

      <div>
        <FieldLabel>Название</FieldLabel>
        <Input name="name" value={formData.name} onChange={handleInput} />
      </div>

      <div>
        <FieldLabel>Полное название</FieldLabel>
        <Input name="longname" value={formData.longname} onChange={handleInput} />
      </div>

      <div>
        <FieldLabel>Описание</FieldLabel>
        <Input.TextArea
          name="description"
          value={formData.description}
          onChange={handleInput}
          rows={3}
        />
      </div>

      <Button type="primary" onClick={apply} disabled={!formData.name}>
        Применить
      </Button>
    </Space>
  );
}

export default ZonePanel;
